import React from 'react';
import { Col, Row } from 'reactstrap';

export default class Maintenance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  UNSAFE_componentWillMount() {
    this.props.verifyIsMaintenance();
  }

  render() {
    return (
      <div>
        <div className="d-flex justify-content-center">
          <Row className="p-0 m-0">
            {/* image */}
            <Col>
              <h1 className="text-center">Maintenance</h1>
              <p>The site is under maintenance. Try again later...</p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
